export const I18N_FALLBACK_LANGUAGE = 'en' as const;

export const I18N_SUPPORTED_LANGUAGES = [
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fr',
  'hi',
  'hr',
  'hu',
  'it',
  'ja',
  'ko',
  'nb',
  'nl',
  'pl',
  'pt',
  'ro',
  'sv',
  'tr',
  'zh-CN',
] as const;

export type SupportedLanguage = (typeof I18N_SUPPORTED_LANGUAGES)[number];
